import React from "react";
import { useI18n } from "../i18n/I18nContext";
import { Thermometer, Leaf, Clock, Shield } from "lucide-react";

const ICONS = [Thermometer, Leaf, Clock, Shield];

const WhatWeDo = () => {
  const { t } = useI18n();
  return (
    <section className="bg-slate-950 text-white scroll-mt-20" id="desinfection" data-testid="what-section">
      <div className="max-w-7xl mx-auto px-5 lg:px-8 section">
        <div className="max-w-3xl">
          <span className="accent-bar" />
          <p className="eyebrow text-slate-400 mb-3">{t.what.eyebrow}</p>
          <h2 className="font-display font-bold text-3xl sm:text-4xl lg:text-5xl tracking-tight leading-[1.05]">
            {t.what.title}
          </h2>
          <p className="mt-6 text-slate-300 leading-relaxed">{t.what.lead}</p>
        </div>

        <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {t.what.bullets.map((b, i) => {
            const Icon = ICONS[i] || Shield;
            return (
              <div key={i} className="border border-slate-800 rounded-md p-6 hover:border-slate-700 transition-colors" data-testid={`what-bullet-${i}`}>
                <div className="w-10 h-10 rounded-sm bg-slate-900 border border-slate-800 flex items-center justify-center mb-5">
                  <Icon size={18} className="text-[#016C36]" strokeWidth={1.75} />
                </div>
                <h3 className="font-display font-semibold text-base text-white">{b.t}</h3>
                <p className="text-sm text-slate-400 mt-2 leading-relaxed">{b.d}</p>
              </div>
            );
          })}
        </div>

        <p className="mt-12 text-xs text-slate-500 italic border-l border-slate-700 pl-4 max-w-3xl leading-relaxed">
          {t.what.disclaimer}
        </p>
      </div>
    </section>
  );
};

export default WhatWeDo;
